import { useContext } from "react";
import ProjectObjectsContext from "Services/ProjectObjectsProvider";

const useProjectObjects = () => {
    return useContext(ProjectObjectsContext);
};

export default useProjectObjects;
